module.exports = __webpack_public_path__ + "img/icon-notification.15686f96.svg";